import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/contact")({
  head: () => pageHead({ title: 'Contact Us', description: 'Contact Rex & Sons RVs in Castle Hayne, NC. Call 910-793-2894 or visit us at 5625 Barbados Blvd.', path: '/contact' }),
  beforeLoad: () => {
    throw redirect({ href: "/contact-us" });
  },
});
